module.exports = __webpack_public_path__ + "static/media/monsters.4b01dc85.png";